import { computed, makeObservable } from 'mobx'

import type AppStore from '@src/app/AppStore'
import VoicePhoneNumberSelectorController from '@src/app/voice/store/VoicePhoneNumberSelectorController'
import type {
  IdentityRow,
  PhoneNumberSelection,
} from '@src/component/phone-number-selector/PhoneNumberSelectorController'
import { getTypeLabel } from '@src/component/phone-number-selector/PhoneNumberSelectorController'
import { isNationalNumber } from '@src/lib/phone-number'
import type { Identity } from '@src/service/model'
import { isDirectNumber } from '@src/service/model'

import ForwardPhoneNumberSelectorKeyboardListController from './ForwardPhoneNumberSelectorKeyboardListController'

export default class ForwardPhoneNumberSelectorController extends VoicePhoneNumberSelectorController {
  override readonly keyboardList = new ForwardPhoneNumberSelectorKeyboardListController(
    this,
  )

  override readonly lang = {
    SELECT_CUSTOM: 'Add ',
    PLACEHOLDER: 'Inboxes, contacts, or numbers...',
  }
  override readonly size = 30
  override readonly mode = 'single'

  constructor(app: AppStore) {
    super(app)
    makeObservable(this, {
      exclusions: computed,
    })
  }

  get currentRow() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access -- FIXME: Fix this ESLint violation!
    return this.search ? this.keyboardList.stepper.item : null
  }

  override get currentPhoneNumber() {
    return null
  }

  override get exclusions(): Identity[] {
    return []
  }

  override get currentPhoneNumberMembers() {
    return []
  }

  override get hasExternalSelections(): boolean {
    return this.selections.some((s) => !isDirectNumber(this.convertSelectionToNumber(s)))
  }

  override get hasResults(): boolean {
    return !!this.search && super.hasResults
  }

  convertSelectionToNumber(selection: PhoneNumberSelection): string {
    switch (selection.type) {
      case 'inbox':
        return selection.to.number
      case 'inbox-member':
        return selection.via
      case 'member':
        return selection.via
      case 'contact':
        return selection.via
      case 'add-number':
      case 'number':
        return selection.to
    }
  }

  override augmentIdentityRow(row: IdentityRow) {
    row.rowMeta.delete(row.id)

    for (const phone of row.phones) {
      const isInternationalNumber = !isNationalNumber(phone.number)

      const disabled = isInternationalNumber
      const tooltipDisabledReason = isInternationalNumber
        ? 'Forwarding can only be set to a U.S. or Canadian number'
        : undefined
      const labelDisabledReason = isInternationalNumber ? '' : undefined

      row.phoneNumberMeta.set(phone.number, {
        disabled,
        tooltipDisabledReason,
        labelDisabledReason,
      })
    }

    const disabled = row.phones.length === 0
    if (!disabled) {
      return
    }

    const tooltipDisabledReason = `${getTypeLabel(row.type)} has no numbers`
    const labelDisabledReason = 'No numbers'
    row.rowMeta.set(row.id, {
      disabled,
      tooltipDisabledReason,
      labelDisabledReason,
    })
  }
}
